/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Push = (props: IconProps) => (
  <Icon {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M2 6C0.895431 6 0 6.89543 0 8V16C0 17.1046 0.89543 18 2 18H22C23.1046 18 24 17.1046 24 16V8C24 6.89543 23.1046 6 22 6H2ZM4 9C2.89543 9 2 9.89543 2 11V13C2 14.1046 2.89543 15 4 15H6C7.10457 15 8 14.1046 8 13V11C8 9.89543 7.10457 9 6 9H4ZM10 10C10 9.44772 10.4477 9 11 9H19C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11H11C10.4477 11 10 10.5523 10 10ZM11 13C10.4477 13 10 13.4477 10 14C10 14.5523 10.4477 15 11 15H15C15.5523 15 16 14.5523 16 14C16 13.4477 15.5523 13 15 13H11Z" />
    <rect opacity="0.5" y="20" width="14" height="2" rx="1" />
    <g opacity="0.5">
      <path d="M14 3C14 2.44772 14.4477 2 15 2H23C23.5523 2 24 2.44772 24 3C24 3.55228 23.5523 4 23 4H15C14.4477 4 14 3.55228 14 3Z" />
      <path d="M7 3C7 2.44772 7.44772 2 8 2H11C11.5523 2 12 2.44772 12 3C12 3.55228 11.5523 4 11 4H8C7.44772 4 7 3.55228 7 3Z" />
    </g>
  </Icon>
);
